import { render, staticRenderFns } from "./pesananperiode.vue?vue&type=template&id=90508264"
import script from "./pesananperiode.vue?vue&type=script&lang=js"
export * from "./pesananperiode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports